import React from 'react';

export interface ErrorProps {
  errorMessage: string;
}

export default function Error(props: ErrorProps) {
  const { errorMessage } = props;
  if (errorMessage === '') {
    return (
      <p>
        We encountered an internal error! This is likely us and not you. Please try again later!
      </p>
    );
  }
  return <p>{errorMessage}</p>;
}
